<template>
  <div class="home">
    <weather></weather>
    <oil-list id="list"></oil-list>
    <div class="freshButton" @click="refresh"></div>
  </div>
</template>
<script>
import Weather from "./components/weather";
import OilList from "./components/oilList";
import bus from "@/utils/bus/bus";
export default {
  components: { Weather, OilList },
  name: "Home",
  methods: {
    refresh() {
      bus.$emit("refreshList");
    }
  }
};
</script>
<style lang="less" scoped>
.home {
  height: 100%;
  background-color: #ffffff;
  background-image: url("~@/assets/weather-bg.jpg");
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  flex-flow: column;
}
.freshButton {
  position: absolute;
  width: 60px;
  height: 60px;
  bottom: 160px;
  right: 20px;
  z-index: 99;
  background: url(../../assets/weather/refresh.png);
  background-size: 60px 60px;
}
</style>
